// extracted by mini-css-extract-plugin
export default {"card":"SelectableCard_card__gMHR5","cardSelected":"SelectableCard_cardSelected__G5Lbn"};